import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Gefeliciteerd! Je hebt {{amount}} aan cashback verdiend.',
  },
};
